export default {"src":"/_next/static/media/User360Dark.cdd92eeb.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};